/**
 * Defines options for a zone-specific generic error message.
 */
export enum ErrorZone {
    CLIENT = 'client',
    ADMIN = 'admin',
    REGISTRATION = 'registration',
}
